import React from "react"
import Typography from "aldoo-ra/Typography"
import DynamicSVG from "aldoo-ra/DynamicSVG"
import CMSRender from "aldoo-ra/CMS/cms-render"

const isEmail = (text) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)
}

const renderCard = (card, id) => {
  !Array.isArray(card.description) && (card.description = [card.description])
  return (
    <div
      key={id}
      className="w-full md:max-w-[390px] lg:max-w-[433px] flex md:flex-col items-center md:items-start md:justify-start bg-theme_white rounded-[24px] gap-4 md:gap-0 px-4 py-6 md:p-6 lg:p-9 shadow-custom_card mx-auto"
    >
      {/* Icon */}
      <DynamicSVG
        recolor={false}
        url={card.icon}
        className="w-[64px] h-[64px] md:mb-3"
      />

      {/* Texts */}
      <div>
        {/* Title */}
        <Typography
          variant="subtitle_32_accent"
          className="text-text mt-0 md:mb-3"
        >
          {card.title}
        </Typography>

        {/* Description Items */}
        <div className="flex flex-col">
          {card.description.map((item, index) =>
            isEmail(item) ? (
              <a
                key={`${id}-desc-${index}`}
                href={`mailto:${item}`}
                className="text-primary hover:text-primary_hov transition-colors"
              >
                <Typography
                  variant="body_20"
                  className="text-primary hover:text-primary_hov transition-colors my-0"
                >
                  {item}
                </Typography>
              </a>
            ) : (
              <Typography
                key={`${id}-desc-${index}`}
                variant="body_20"
                className="my-0"
              >
                {item}
              </Typography>
            )
          )}
        </div>
      </div>
    </div>
  )
}

function ContactUsSection() {
  return (
    <div className="w-full pt-5 pb-8 md:pb-[56px] lg:pb-[132px] px-4 md:px-[56px] mx-auto">
      <CMSRender
        contentType="ContactUsSection"
        renderItem={(section) => {
          return (
            <div className="w-full max-w-[450px] md:max-w-full md:w-[660px] lg:w-[914px] flex flex-col items-center mx-auto">
              <Typography
                variant="h1"
                className="text-center mb-8 md:mb-12"
              >
                {section.title}
              </Typography>

              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8 justify-center">
                {section.cards.map(renderCard)}
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

export const AldooComponent = {
  id: 'ContactUsSection',
  component: ContactUsSection,
  input: {},
  meta: {
    name: 'Contact Us Section',
    description: 'Contact information cards with icons and email links',
    category: 'Marketing',
  },
}

export default ContactUsSection
